export const DATE_POSTED_TYPES = [
    'day',
    'week',
    '2-4week',
    '5-8week',
    '9-12week',
    '12week',
];
